import * as React from 'react';
import {renderReact} from 'hypernova-react';
import {I18nContext, I18nManager} from '@shopify/react-i18n';
import {Categories} from './Categories';

const manager = new I18nManager({locale: 'en-CA'});

export function CategoriesSection(props) {
  return (
    <I18nContext.Provider value={manager}>
      <Categories {...props} />
    </I18nContext.Provider>
  );
}

export default renderReact('Categories', CategoriesSection);
